import React from 'react';

const CustomerPage = React.lazy(() => import('pages/Customer/pages/CustomerPage'));
const CustomerAddPage = React.lazy(() => import('pages/Customer/pages/CustomerAddPage'));
const CustomerDetailPage = React.lazy(() => import('pages/Customer/pages/CustomerDetailPage'));

const CustomerRoutes = [
  {
    path: '/customer',
    exact: true,
    name: 'Danh sách khách hàng',
    function: 'CRM_ACCOUNT_VIEW',
    component: CustomerPage,
  },
  {
    path: '/customer/add',
    exact: true,
    name: 'Thêm khách hàng',
    function: 'CRM_ACCOUNT_ADD',
    component: CustomerAddPage,
  },
  {
    path: '/customer/edit/:account_id',
    exact: true,
    name: 'Chỉnh sửa khách hàng',
    function: 'CRM_ACCOUNT_EDIT',
    component: CustomerAddPage,
  },
  {
    path: '/customer/detail/:account_id',
    exact: true,
    name: 'Chi tiết khách hàng',
    function: 'CRM_ACCOUNT_VIEW',
    component: CustomerDetailPage,
  },
];

export default CustomerRoutes;
